import React, { useEffect } from 'react';
import './slider.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

function Slider() {
    useEffect(() => {
        const carouselElement = document.getElementById('myCarousel');
        if (carouselElement) {
            new window.bootstrap.Carousel(carouselElement, {
                interval: 3000,
                ride: 'carousel'
            });
        }
    }, []);

    return (
        <div id="myCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="3000">
            <div className="carousel-indicators">
                <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>

            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src="/assets/offer.jpeg" className="img-fluid slide-image" alt="First Slide" />
                </div>

                <div className="carousel-item">
                    <img src="/assets/sliderss2.png" className="img-fluid slide-image" alt="Second Slide" />
                </div>

                <div className="carousel-item">
                    <img src="/assets/slider-1.jpg" className="img-fluid slide-image" alt="Third Slide" />
                </div>
            </div>
        </div>
    );
}

export default Slider;
